export function committerDisplayName(committer: string) {
  const cleanedCommitter = committer.trim();
  if (!cleanedCommitter) {
    return 'Unknown';
  }
  const indexOfEmail = cleanedCommitter.indexOf('<');
  if (indexOfEmail <= 0) {
    return cleanedCommitter;
  }
  return cleanedCommitter.substring(0, indexOfEmail).trim();
}
